<template>
  <v-img
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span class="trace red--text">base/Img.vue</span>
    <span class="trace red--text"> [ {{ $attrs }} ]</span>

    <slot />
  </v-img>
</template>

<script>
  export default {
    name: 'BaseImage',
  }
</script>
